import { styled } from '@mui/material/styles';
import { Paper, Box, Typography } from '@mui/material';

export const StyledPaper = styled(Paper)(({ theme }) => ({
  backgroundColor: '#1a1a1a',
  color: '#ffffff',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  borderRadius: theme.spacing(1),
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.4)',
  overflow: 'hidden',
  transition: 'all 0.2s ease',
}));

export const ContentWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  width: '100%',
  padding: theme.spacing(1.5),
  gap: theme.spacing(1.5),
  overflow: 'auto',

  '&::-webkit-scrollbar': {
    width: '6px',
  },
  '&::-webkit-scrollbar-track': {
    background: '#121212',
  },
  '&::-webkit-scrollbar-thumb': {
    background: '#333',
    borderRadius: '3px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    background: '#555',
  },
}));

export const PanelContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1.2),
  width: '100%',
  boxSizing: 'border-box',
  backgroundColor: '#161616',
  borderRadius: theme.spacing(0.8),
  boxShadow: '0 2px 6px rgba(0, 0, 0, 0.2)',
  display: 'flex',
  flexDirection: 'column',
  marginBottom: theme.spacing(1),

  '.MuiDataGrid-root': {
    flex: 1,
    border: 'none',
    width: '100%',
    '.MuiDataGrid-cell': {
      borderBottom: '1px solid rgba(255, 255, 255, 0.05)',
      padding: '4px 8px',
    },
    '.MuiDataGrid-columnHeaders': {
      backgroundColor: '#222',
      color: '#ffffff',
      fontWeight: 'bold',
      borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
      minHeight: '40px !important',
      maxHeight: '40px !important',
      lineHeight: '40px',
    },
    '.MuiDataGrid-row:nth-of-type(odd)': {
      backgroundColor: '#181818',
    },
    '.MuiDataGrid-row:nth-of-type(even)': {
      backgroundColor: '#202020',
    },
    '.MuiDataGrid-row:hover': {
      backgroundColor: '#2a2a2a',
    },
  },
}));

export const PanelTitle = styled(Typography)(({ theme }) => ({
  fontSize: '0.85rem',
  fontWeight: 600,
  color: '#ffffff',
  fontFamily: '"Poppins", sans-serif',
  letterSpacing: '0.4px',
  textTransform: 'uppercase',
  margin: theme.spacing(0.5, 0),
}));
